import React from "react";

// Import only the active informational pages
import Landing from "./Landing";
import Publications from "./Publications";
import FAQ from "./FAQ";
import About from "./About"; 

export class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Default to the Landing page on initial load
      view: "Landing",
    };
  }

  /**
   * Navigation handler passed down to all child pages.
   * Based on your other files, it expects to be called like: 
   * const eventHandler = this.props.onClickGoToPage("PageName");
   * eventHandler();
   */
  onClickGoToPage = (pageName) => () => {
    this.setState({ view: pageName });
    // Optional but recommended: Scroll to top on page change
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  render() {
    // A simple switch router to render the correct component based on state
    switch (this.state.view) {
      case "Landing":
        return <Landing view={this.state.view} onClickGoToPage={this.onClickGoToPage} />;
      
      case "Publications":
        return <Publications view={this.state.view} onClickGoToPage={this.onClickGoToPage} />;
      
      case "FAQ":
        return <FAQ view={this.state.view} onClickGoToPage={this.onClickGoToPage} />;
      
      case "About":
        return <About view={this.state.view} onClickGoToPage={this.onClickGoToPage} />;
      
      default:
        // Fallback catch-all
        return <Landing view={this.state.view} onClickGoToPage={this.onClickGoToPage} />;
    }
  }
}